// Counterpart of webapp/src/store/teams.ts

import {create} from 'zustand'
import client, {Team} from '../api/client'
import {Constants} from '../common/constants'
import {Utils} from '../common/utils'

type TeamsState = {
    teams: Team[]
    activeTeamId: string
    loadTeams: () => Promise<Team[]>
    setTeamId: (teamId: string) => void
}

function lastTeamId(): string {
    return Utils.getItem(Constants.localStorageKeys.lastTeamId) || Constants.globalTeamId
}

export const useTeams = create<TeamsState>((set) => ({
    teams: [],
    activeTeamId: lastTeamId(),

    async loadTeams() {
        const teams = await client.getTeams()
        const activeTeamId = teams.some((t) => t.id === lastTeamId()) ? lastTeamId() : (teams[0]?.id || Constants.globalTeamId)
        client.setTeamId(activeTeamId)
        set({teams, activeTeamId})
        Utils.setItem(Constants.localStorageKeys.lastTeamId, activeTeamId)
        return teams
    },

    setTeamId(teamId) {
        client.setTeamId(teamId)
        Utils.setItem(Constants.localStorageKeys.lastTeamId, teamId)
        set({activeTeamId: teamId})
    },
}))

export const getActiveTeamId = (state: TeamsState): string => state.activeTeamId
export const getTeams = (state: TeamsState): Team[] => state.teams
